import { useEffect, useRef, useState } from "react";
import { Spinner, Button } from "react-bootstrap";
import { apiUrls } from "../config/apiUrls.const";
import { _get } from "../services/apiClient";
import eventBus from "../utils/EventBus";
import { getStoredInfo } from "../utils/LocalStorageManager";
import { useNavigate } from "react-router-dom";
import MapModal from "./components/MapModal";
import { BookingForm, BookingFormRef } from "./components/BookingForm";
import ServiceItemGrid from "./components/ServiceItemGrid"; // Import your new Grid

export default function Home() {
  const navigate = useNavigate();
  const [activeLocation] = useState<any | null>(getStoredInfo('location') || null);
  
  // NEW: Single state for all grouped data
  const [data, setData] = useState<Record<string, any[]> | null>(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [mapModalData, setMapModalData] = useState<any | null>(null);
  const [userLocation, setUserLocation] = useState<{ lat: number; lon: number } | null>(null);

  const bookingFormRef = useRef<BookingFormRef>(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => setUserLocation({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      (err) => console.error("Location error:", err)
    );
  }, []);

  const handleMapModal = (lat: number, lon: number, address: string) => {
    setMapModalData({ lat, lon, address });
  };

  const fetchCategorizedItems = async (getLocation: any = null) => {
    setLoading(true);
    setError(null);

    try {
      const locationToUse = getLocation ? getLocation : activeLocation;
      const response = await _get(apiUrls.serviceItems, {
        division_id: locationToUse?.division?.id || 0,
        district_id: locationToUse?.district?.id || 0,
        thana_id: locationToUse?.thana?.id || 0,
      });

      // Directly set the grouped data (e.g., { salon: [], spa: [] })
      setData(response?.data?.data || {});
    } catch (err) {
      setError("Failed to fetch categorized items");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeLocation) fetchCategorizedItems();

    const handleLocationUpdate = () => {
      const stored = getStoredInfo('location');
      fetchCategorizedItems(stored);
    };

    eventBus.on("LOCATION_UPDATED", handleLocationUpdate);
    return () => {
      eventBus.off("LOCATION_UPDATED", handleLocationUpdate);
    };
  }, []);

  const handleItemClick = (itemId: any) => navigate(`/service-details?id=${itemId}`);
  const businessPage = (bizCode: string) => navigate(`/webpage/${bizCode}`);

  if (loading) return <div className="text-center py-5"><Spinner animation="border" /><p>Loading Services...</p></div>;

  if (error) return (
    <div className="alert alert-danger text-center">
      {error} <br />
      <Button size="sm" onClick={() => fetchCategorizedItems()}>Retry</Button>
    </div>
  );

  return (
    <>
      {/* DYNAMIC RENDERING: 
         This replaces the manual ServiceSection calls 
      */}
      {data && Object.entries(data).map(([groupName, items]) => (
        <div key={groupName} className="mt-2">
          <h3 className="section-title mb-2">
             {/* Converts 'salon' to 'Salon Services' */}
             {groupName.charAt(0).toUpperCase() + groupName.slice(1)} Services
          </h3>
          <ServiceItemGrid 
            items={items as any[]} 
            title={groupName}
            handleItemClick={handleItemClick}
            businessPage={businessPage}
            handleMapModal={handleMapModal}
            bookingFormRef={bookingFormRef}
          />
        </div>
      ))}

      {mapModalData && (
        <MapModal
          show={!!mapModalData}
          onHide={() => setMapModalData(null)}
          lat={mapModalData.lat}
          lon={mapModalData.lon}
          address={mapModalData.address}
          userLocation={userLocation || undefined}
        />
      )}

      <BookingForm ref={bookingFormRef} onSuccess={() => {}} />
    </>
  );
}